import { MailboxInfo } from 'owa-client-ids';
import {
    CardDetails,
    MessageContext,
    getCardTypeFromCardDetails,
    CardOamAppNameMap,
    TelemetryProvider,
} from 'owa-actionable-message';

/**
 * logTelemetry Event for Disabled Event
 */
const TRANSACTION_CARD_DISABLED = 'TransactionCardDisabled';

/**
 * Key for fetching message card context from CardDetails.card json
 */
const messageCardContextPropName = 'messageCardContext';

/**
 * Gets the enabled status of a AdaptiveCard of type Transaction
 *
 * @param details
 * @param item
 * @param mailboxInfo
 * @return {true|false} true iff card is of type Transaction and flight is enabled
 */
export default function getDisabledTransactionCards(
    cardDetails: CardDetails,
    mailboxInfo: MailboxInfo,
    disableTransactionCard: boolean,
    messageContext: MessageContext,
    telemetryProvider: TelemetryProvider
): boolean {
    const { card } = cardDetails;
    if (card && card.hasOwnProperty(messageCardContextPropName)) {
        const { messageCardContext } = card;

        if (!messageCardContext) {
            return false;
        }

        const disabled =
            getCardTypeFromCardDetails(cardDetails) === CardOamAppNameMap.XeroOpay &&
            disableTransactionCard;
        if (disabled) {
            telemetryProvider.logTelemetry({
                messageContext: messageContext,
                eventName: TRANSACTION_CARD_DISABLED,
                cardDetails: cardDetails,
            });
        }
        return disabled;
    } else {
        return false;
    }
}
